import { handleActions } from 'redux-actions';
import { createReducer } from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "systemRoles",
    "system-roles",
    "SystemRoleForm",
    "/system-roles",
);

// Override initialState to set default descending ordering
const customInitialState = {
    ...initialState,
    ordering: '-id',
};

export default handleActions(reducers, customInitialState);
